<template>
  <tbody
    class="dark:divide-ontick-steel-500 divide-ontick-steel-300 dark:bg-ontick-graphite-500 divide-y bg-gray-200 text-xs"
  >
    <tr v-for="order in orders" :key="order.alg_ord_id">
      <td class="td">
        <div class="flex items-center justify-center gap-2" v-if="section === 'PRIVATE'">
          <div class="relative h-3 w-3">
            <div
              class="absolute h-3 w-3 rounded-full"
              :class="
                ['ACTIVE', 'NEW'].includes(order.info.alg_ord_state) ||
                ['ACTIVE', 'NEW'].includes(order.info.trail_order_status)
                  ? 'bg-ontick-green-600'
                  : 'bg-gray-400'
              "
            ></div>
            <div
              v-if="
                ['ACTIVE', 'NEW'].includes(order.info.alg_ord_state) ||
                ['ACTIVE', 'NEW'].includes(order.info.trail_order_status)
              "
              class="bg-ontick-green-600 absolute h-3 w-3 animate-ping rounded-full"
            ></div>
          </div>
          <ontick-switch-component
            :active="
              ['ACTIVE', 'NEW'].includes(order.info.alg_ord_state) ||
              ['ACTIVE', 'NEW'].includes(order.info.trail_order_status)
            "
            :disabled="['STOPPED'].includes(order.info.trail_order_status)"
            @switch="startDialog(order)"
          />
          <!-- <button class="p-1 filter hover:brightness-125 transition-all">
            <i v-html="$icons.kebab"></i>
          </button> -->
        </div>
        <!-- <marketplace-add-component
          v-else
          @click.native="
            duplicate(order.alg_ord_code, getSelectedAccount.account_id)
          "
          label="Adicionar"
        /> -->
      </td>
      <td class="td">
        <div class="flex flex-col gap-1">
          <!-- <div class="h-6 w-6">
            <img
              :src="order.info.partner_logo"
              :alt="order.info.alg_ord_partner"
            />
          </div> -->
          <span class="font-semibold">
            {{ order.info.alg_ord_name }}
          </span>
          <span class="text-gray-500"> ID: {{ order.info.trail_order_id }} </span>
        </div>
      </td>
      <td class="td">
        <div class="flex items-center gap-2">
          <div class="flex flex-col gap-2">
            <symbol-progress-v-2-component
              :symbolName="order.entry_order.symbol_1"
              :symbolDirection="order.entry_order.symbol_1_direction"
              :plannedVolume="order.entry_order.planned_volume"
              :filledVolume="order.entry_order.filled_volume"
              :tradingPhase="order.entry_order.order_trading_phase"
              :symbolPrice="order.entry_order.symbol_1_price"
              :orderState="order.entry_order.order_state"
            />
            <symbol-progress-v-2-component
              :symbolName="order.entry_order.symbol_2"
              :symbolDirection="order.entry_order.symbol_2_direction"
              :plannedVolume="order.entry_order.planned_volume"
              :filledVolume="order.entry_order.filled_volume"
              :tradingPhase="order.entry_order.order_trading_phase"
              :symbolPrice="order.entry_order.symbol_2_price"
              :orderState="order.entry_order.order_state"
            />
          </div>
          <div class="flex flex-col">
            <span>
              {{ order.entry_order.entry_value }}
            </span>
            <span class="text-gray-500">
              {{ calcTypeDict(order.entry_order.calc_type) }}
            </span>
          </div>
        </div>
      </td>
      <td class="td">
        <div class="flex items-center gap-2">
          <div class="flex flex-col gap-2">
            <symbol-progress-v-2-component
              :symbolName="order.exit_order.symbol_1"
              :symbolDirection="order.exit_order.symbol_1_direction"
              :plannedVolume="order.exit_order.planned_volume"
              :filledVolume="order.exit_order.filled_volume"
              :tradingPhase="order.exit_order.order_trading_phase"
              :symbolPrice="order.exit_order.symbol_1_price"
              :orderState="order.exit_order.order_state"
            />
            <symbol-progress-v-2-component
              :symbolName="order.exit_order.symbol_2"
              :symbolDirection="order.exit_order.symbol_2_direction"
              :plannedVolume="order.exit_order.planned_volume"
              :filledVolume="order.exit_order.filled_volume"
              :tradingPhase="order.exit_order.order_trading_phase"
              :symbolPrice="order.exit_order.symbol_2_price"
              :orderState="order.exit_order.order_state"
            />
          </div>
          <div class="flex flex-col">
            <span>
              {{ order.entry_order.entry_value }}
            </span>
            <span class="text-gray-500">
              {{ calcTypeDict(order.entry_order.calc_type) }}
            </span>
          </div>
        </div>
      </td>
      <td class="td">
        <div class="flex flex-col gap-1">
          <div class="flex items-center gap-1">
            <div class="scale-75 transform">
              <i v-html="$icons.play_red" v-if="order.pnl.fin < 0"></i>
              <i v-html="$icons.play_green" v-else-if="order.pnl.fin > 0"></i>
              <i v-else>
                <div class="h-3 w-3 rounded-full bg-gray-500"></div>
              </i>
            </div>
            <span>
              {{ calculaPNL(order.entry_order, order.exit_order) | currency }}
            </span>
          </div>
          <span class="text-gray-500"> +12% </span>
        </div>
      </td>
      <td class="td">
        <div class="flex w-full items-center justify-center">
          <button @click="openDetailsModal(order)" class="text-ontick-blue-600 p-2 transition-all hover:brightness-125">
            <i v-html="$icons.details"></i>
          </button>
        </div>
      </td>
    </tr>
    <ontick-modal-component size="small" :open="startModalIsActive" @close="startModalIsActive = false">
      <start-modal-component :order="order" @close="startModalIsActive = false" />
    </ontick-modal-component>
    <ontick-modal-component size="small" :open="stopModalIsActive" @close="stopModalIsActive = false">
      <stop-modal-component :order="order" @close="stopModalIsActive = false" />
    </ontick-modal-component>
  </tbody>
</template>

<script>
import OntickFormDropdownComponent from "../../../../shared/components/basic/ontick-form-dropdown.component.vue";
import ontickSwitchComponent from "../../../../shared/components/basic/ontick-switch.component.vue";
import MarketplaceAddComponent from "../../../marketplace/components/products/card/marketplace-add.component.vue";
import OptionsMenuComponent from "./options-menu.component.vue";
import SymbolPairStatusComponent from "./symbol-pair-status.component.vue";
import * as icons from "../../../../assets/icons/investments";
import { mapGetters } from "vuex";
import event_bus from "../../../../shared/utils/event_bus";
import OntickModalComponent from "../../../../shared/components/basic/ontick-modal.component.vue";
import StartModalComponent from "../start-modal.component.vue";
import StopModalComponent from "../stop-modal.component.vue";
import AlgoOrderSummaryComponent from "../algo-order-summary.component.vue";
import SymbolProgressV2Component from "./symbol-progress-v2.component.vue";
// import OntickBrokerLogoComponent from '../../../../shared/components/basic/ontick-broker-logo.component.vue';
export default {
  components: {
    ontickSwitchComponent,
    OptionsMenuComponent,
    SymbolPairStatusComponent,
    MarketplaceAddComponent,
    OntickFormDropdownComponent,
    OntickModalComponent,
    StartModalComponent,
    StopModalComponent,
    AlgoOrderSummaryComponent,
    SymbolProgressV2Component,
  },

  props: {
    orders: {
      type: Array,
    },
    section: {
      type: String,
    },
    resultFormat: {
      type: String,
    },
  },

  data() {
    return {
      icons,
      optionDefault: {
        icon: icons.details,
        label: null,
      },

      startModalIsActive: false,
      stopModalIsActive: false,
      order: null,
    };
  },

  computed: {
    ...mapGetters({ getSelectedAccount: "accountTypes/getSelectedAccount" }),
    optionsSelect() {
      return [
        { icon: icons.editParams, label: "Editar" },
        // { icon: icons.performance, label: "Histórico" },
        {
          icon: icons.removeInvestment,
          label: "Apagar",
        },
      ];
    },
  },

  methods: {
    calculaPNL(entry, exit) {
      let pnlComprada, pnlVendida, pnlFinal;
      if (entry.symbol_1_direction === "BUY") {
        pnlComprada =
          exit.filled_volume * exit.symbol_1_price_avg +
          exit.volume_leaves * exit.symbol_1_curr_price -
          entry.filled_volume * entry.symbol_1_price_avg;
        pnlVendida =
          entry.filled_volume * entry.symbol_2_price_avg -
          (exit.filled_volume * exit.symbol_2_price_avg + exit.volume_leaves * exit.symbol_2_curr_price);
        pnlFinal = pnlComprada + pnlVendida;
        return pnlFinal;
      } else if (entry.symbol_1_direction === "SELL") {
        pnlComprada =
          exit.filled_volume * exit.symbol_2_price_avg +
          exit.volume_leaves * exit.symbol_2_curr_price -
          entry.filled_volume * entry.symbol_2_price_avg;
        pnlVendida =
          entry.filled_volume * entry.symbol_1_price_avg -
          (exit.filled_volume * exit.symbol_1_price_avg + exit.volume_leaves * exit.symbol_1_curr_price);
        pnlFinal = pnlComprada + pnlVendida;
        return pnlFinal;
      }
      return null;
    },
    calcTypeDict(calc_type) {
      switch (calc_type) {
        case "FACTOR":
          return "Fator";
        case "DIFFERENCE":
          return "Diferença";
        case "LINEAR_FUNCTION":
          return "Resíduo";
        default:
          return calc_type;
      }
    },
    reload() {
      event_bus.$emit("RELOAD_ALGO_ORDERS");
    },
    manageOrder(alg_ord_id, alg_ord_state) {
      if (alg_ord_state === "ACTIVE") {
        return this.$api
          .post(this.$endpoint.STOP_TRAIL_ORDER, {
            alg_ord_id,
            account_id: this.getSelectedAccount.account_id,
          })
          .then((res) => {
            // console.log(res);
            this.$swal("Ordem parada", res.data.msg, "success");
            this.reload();
          })
          .catch((err) => {
            console.error(err);
            this.$swal("Erro", err.data.msg, "error");
          });
      }

      return this.$api
        .post(this.$endpoint.START_ALGO_ORDER, {
          alg_ord_id,
          account_id: this.getSelectedAccount.account_id,
        })
        .then((res) => {
          // console.log(res);
          this.$swal("Ordem iniciada", res.data.msg, "success");
          this.reload();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    optionSelected(event, item) {
      switch (event.label) {
        case "Apagar":
          this.$api
            .post(this.$endpoint.DELETE_ALGO_ORDER, {
              alg_ord_id: item.alg_ord_id,
              account_id: this.getSelectedAccount.account_id,
            })
            .then((res) => {
              // console.log(res);
              this.$swal("Ordem apagada", res.data.msg, "success");
              this.reload();
            })
            .catch((err) => {
              console.error(err);
              this.$swal("Erro", err.data.msg, "error");
            });
          break;
        case "Editar":
          this.$router.push({
            name: "Editar ordem Long & Short",
            params: {
              alg_ord_id: item.alg_ord_id,
            },
          });
          break;
      }
    },
    resultIcon(result) {
      if (result > 0) {
        return this.$icons.play_green;
      } else if (result < 0) {
        return this.$icons.play_red;
      }
    },
    openDetailsModal(order) {
      this.$emit("open-details", order.info.alg_ord_id || order.info.trail_order_id);
    },

    duplicate(order_code, account_id) {
      return this.$api
        .post(this.$endpoint.DUPLICATE_ALGO_ORDER, { order_code, account_id })
        .then((res) => {
          // console.log(res);
          this.$swal("Ordem adicionada", res.data.msg, "success").then(() => {
            event_bus.$emit("GO_TO_PUBLIC_ALGO_ORDERS");
          });
        })
        .catch((err) => {
          console.error(err);
          this.$swal("Erro", err.data.msg, "error");
        });
    },
    startDialog(order) {
      // if (["NEW", "FILLED", "STOPPED"].includes(order.info.alg_ord_state)) {
      //   this.order = order;
      //   this.startModalIsActive = true;
      // } else {
      //   this.order = order;
      //   this.stopModalIsActive = true;
      // }
      this.order = order;
      this.stopModalIsActive = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.td {
  @apply p-3 text-left;
}
</style>
